import {Component, computed, input, output, signal} from '@angular/core';
import {BaseDialogComponent} from '../base-dialog/base-dialog.component';
import {DirectusTooltipComponent} from '../../directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-icon-confirm-dialog',
  imports: [BaseDialogComponent, DirectusTooltipComponent],
  templateUrl: './icon-confirm-dialog.component.html',
})
export class IconConfirmDialogComponent {
  readonly icon = input.required<string>();
  readonly header = input.required<string>();
  readonly colorClass = input('text-red');
  readonly tooltipKey = input('');
  readonly width = input('450px');
  readonly confirmLabel = input('common.confirm');
  readonly cancelLabel = input('common.cancel');
  readonly confirmHidden = input(false);
  readonly testId = input('icon-confirm-dialog');
  readonly opened = output<void>();
  readonly confirm = output<void>();

  protected readonly iconClass = computed(() => `${this.icon()} ${this.colorClass()}`);

  protected readonly submitLabel = computed(() =>
    this.confirmHidden() ? '' : this.confirmLabel(),
  );

  protected readonly visible = signal(false);

  protected open(): void {
    this.opened.emit();
    this.visible.set(true);
  }

  protected close(): void {
    this.visible.set(false);
  }

  protected onConfirm(): void {
    this.confirm.emit();
    this.visible.set(false);
  }
}
